import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OauthTokenData } from 'oauth-lib';
import { throwError } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, filter, switchMap, take } from 'rxjs/internal/operators';
import { SecurityService } from 'src/app/services/security-service/security.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class OauthInterceptorService implements HttpInterceptor {

  private refreshingToken = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private userStorageService: UserStorageService,
              private securityService: SecurityService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.addOAuthHeader(req)).pipe(
      catchError(
        (error) => {
          if (this.isExcluded(req)) {
            return throwError(error);
          }

          if (error.status !== 401) {
            return throwError(error);
          }

          if (this.refreshingToken) {
            return this.refreshTokenSubject.pipe(
              filter(res => res !== null),
              take(1),
              switchMap(() =>  next.handle(this.addOAuthHeader(req)))
            );
          } else {
            this.refreshingToken = true;
            this.refreshTokenSubject.next(null);
            return this.securityService.requestOAuthToken().pipe(
              switchMap((token: OauthTokenData) => {
                this.refreshingToken = false;
                this.userStorageService.setOAuthToken(token.access_token);
                this.refreshTokenSubject.next(token);
                return next.handle(this.addOAuthHeader(req));
              }),
              catchError((err) => {
                this.refreshingToken = false;
                return throwError(error);
              })
            );
          }
        }
      )
    );
  }

  private addOAuthHeader(req) {
    if (this.isExcluded(req)) {
      return req;
    }
    if (!this.userStorageService.getOAuthToken()) {
      this.userStorageService.setOAuthToken(' ');
    }

    return req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + this.userStorageService.getOAuthToken()) });
  }

  private isExcluded(req: HttpRequest<any>) {
    const salesRequest = new RegExp('api/ver-ventas');
    const oauthTokenRequest = new RegExp('oauth/token');
    const i18nRequest = new RegExp('/assets/i18n/');
    if (oauthTokenRequest.test(req.url) || i18nRequest.test(req.url) || salesRequest.test(req.url)) {
      return true;
    }
    return false;
  }
}
